import fetch, { fetchJson, postJson } from 'utils/fetch';

export const getZoneById = id =>
  fetchJson(`/pco-manager/zones/${id}/plan.json`);

export const createZone = (interventionId, taskType, data, comment) =>
  postJson(
    `/pco-manager/zones/create.json?intervention_id=${
      interventionId
    }&task_type=${taskType}`,
    JSON.stringify({
      ...data,
      comment: comment,
    })
  );

export const copyZone = (
  interventionId,
  taskType,
  zoneId,
  zoneTemplateId,
  fromTemplate
) =>
  postJson(
    `/pco-manager/zones/copy.json?intervention_id=${interventionId}&task_type=${
      taskType
    }`,
    JSON.stringify({
      zoneId: parseInt(zoneId, 10),
      zoneTemplateId: parseInt(zoneTemplateId, 10),
      fromTemplate: fromTemplate,
    })
  );

export const createComment = (zone, comment, photo) => {
  const data = new FormData();
  data.append('comment', JSON.stringify(comment));
  data.append('photo', photo);

  return fetch(`/pco-manager/zones/${zone}/comments.json`, {
    method: 'POST',
    body: data,
  }).then(res => res.json());
};

export const updatePoint = (point, photo) => {
  if (point.type === 'point') {
    return postJson(
      `/pco-manager/zones/points.json/${point.id}`,
      JSON.stringify(point)
    );
  } else if (point.type === 'marker') {
    return postJson(
      `/pco-manager/zones/markers.json/${point.id}`,
      JSON.stringify(point)
    );
  } else {
    const data = new FormData();
    data.append('comment', JSON.stringify(point));
    data.append('photo', photo);

    return fetch(`/pco-manager/zones/comments.json/${point.id}`, {
      method: 'POST',
      body: data,
    }).then(res => res.json());
  }
};

export const deletePoint = point => {
  let url;
  if (point.type === 'point') {
    url = `/pco-manager/zones/points.json/${point.id}`;
  } else if (point.type === 'marker') {
    url = `/pco-manager/zones/markers.json/${point.id}`;
  } else {
    url = `/pco-manager/zones/comments.json/${point.id}`;
  }

  return fetch(url, {
    method: 'DELETE',
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/api/index.js